import { BuilderConfig } from '../../../types/Builder';
import B2BCategoryFeature, { CategoryFeatureProps } from './b2b-category-feature';

export const B2BCategoryFeatureBuilderConfig = {
    name: 'B2B Category Feature',
    inputs: [
        {
            name: 'category',
            type: 'text',
        },
    ],
};

const builderConfig: BuilderConfig<CategoryFeatureProps> = {
    component: B2BCategoryFeature,
    config: B2BCategoryFeatureBuilderConfig,
};

export default builderConfig;
